const FILE_PICKER_FILE_KEY_PREFIX = 'files::';

export { FILE_PICKER_FILE_KEY_PREFIX };
